export default __webpack_public_path__ + "media/images/block-939df3e7a090b8ea7ba362a48d536062.png";